import React from 'react';

import {
  Breadcrumb as ChakraBreadCrumb,
  BreadcrumbItem as ChakraBreadcrumbItem,
  BreadcrumbLink as ChakraBreadcrumbLink,
} from '@chakra-ui/react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { ChevronRight } from 'assets/assetsV1/iconComponents';

export const BreadCrumb = ({ children, ...props }) => (
  <ChakraBreadCrumb
    spacing="2px"
    separator={<ChevronRight color="text.g2" boxSize="14px" />}
    sx={{
      ol: {
        padding: 0,
        margin: 0,
      },
    }}
    {...props}
  >
    {children}
  </ChakraBreadCrumb>
);

export const BreadcrumbItem = styled(ChakraBreadcrumbItem)`
  font-size: 12px;
  color: ${({ isCurrentPage, theme }) => (isCurrentPage ? theme.colors.text.g1 : theme.colors.text.g2)};
  font-weight: ${({ isCurrentPage }) => (isCurrentPage ? 600 : 400)};
`;

export const BreadcrumbLink = ({ children, to, onClick = () => {}, ...props }) => (
  <ChakraBreadcrumbLink as={Link} to={to} textDecoration="none !important" {...props} onClick={onClick}>
    {children}
  </ChakraBreadcrumbLink>
);
